import React from "react";
import i18n from "../../../../constants/i18n";
import { ADMIN_AUDIT_EVENT_PICKER_ENTRIES } from "../../../../constants/picker-entries-constants";
import Et3Button from "../../../../core/et3-button";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Date from "../../../../core/et3-input/et3-date";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import getAuditedEventsStore from "../../../../stores/auditor-store/audited-events-store";
import getRootStore from "../../../../stores/core/root-store";
import { ISSUES_ARRAY } from "../../../../constants/input-entries-constants";
import { isPositiveNumber } from "et3-type-guards";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";
import { reducerToZeroIfUndefined } from "../../../../helpers/et3-picker-data-helper";

const AuditedEventsForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const allAdmins = getRootStore().allAdmins.get();
  const isEnabled = isPositiveNumber(
    reducerToZeroIfUndefined(
      parseInt(getAuditedEventsStore().adminInput.get().value, 10)
    )
  );

  return (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("ADMIN")}
          options={allAdmins}
          value={getAuditedEventsStore().adminInput.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditedEventsStore().setAdmin(value);
          }}
          onEnter={() => getAuditedEventsStore().getAuditedEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("TYPE")}
          options={ADMIN_AUDIT_EVENT_PICKER_ENTRIES}
          value={getAuditedEventsStore().typeInputAuditedEvent.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditedEventsStore().typeInputAuditedEvent.set(value);
          }}
          onEnter={() => getAuditedEventsStore().getAuditedEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Picker
          label={i18n.get("ISSUE_TYPE")}
          options={ISSUES_ARRAY}
          value={getAuditedEventsStore().typeInputAuditedIssue.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            getAuditedEventsStore().typeInputAuditedIssue.set(value);
          }}
          onEnter={() => getAuditedEventsStore().getAuditedEvents()}
          isMultiple={false}
          style={{}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1200}
        height={75}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MIN")}
          dateInputObservable={getAuditedEventsStore().dateMinInput}
          isEnabled={true}
        />
        <Et3Margin top={0} bottom={0} left={0} right={30} />
        <Et3Date
          hasMax={true}
          hasMin={false}
          label={i18n.get("DATE_MAX")}
          dateInputObservable={getAuditedEventsStore().dateMaxInput}
          isEnabled={true}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        onClick={async () => {
          await getAuditedEventsStore().getAuditedEvents();
        }}
        isEnabled={isEnabled}
        size="LARGE"
        text="GET"
        type="GET"
      />
    </React.Fragment>
  );
});
export default AuditedEventsForm;
